import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { CircularProgress, LinearProgress } from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { useParams } from "react-router-dom";
import { api_Routes } from "../../../tools/api_Routes";
import OrderDetailsPage from "../../../UI/Orders/OrderDetails";

const OrdersDetailsPanel = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({});

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Orders.GetOne}${id}`,
      });
      if (response) {
        setFormData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Order details <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Order details: {formData?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? <LinearProgress /> : <OrderDetailsPage data={formData} />
        }
      />
    </div>
  );
};

export default React.memo(OrdersDetailsPanel);
